import { render, staticRenderFns } from "./home-footer.vue?vue&type=template&id=48f67763"
import script from "./home-footer.vue?vue&type=script&lang=ts"
export * from "./home-footer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/usr/src/app/components/Header.vue').default,Footer: require('/usr/src/app/components/Footer.vue').default})
